import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import '../index.scss'
import OriginalPublisherCardAddWriters from '@Components/Cards/WorkDetailCards/OriginalPublisherCards/OriginalPublisherCardAddWriters'
import { StoresContext } from '@App/contexts'
import { Navigate } from 'react-router'
import RootStore from '@App/stores/root-store'
import Pluralize from 'pluralize'
import WizardStepHeading from '@Components/WizardFlow/WizardStepHeading'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'

const PublishersRelationsStep = () => {
    const { workStore, rightsholderStore } = useContext<RootStore>(StoresContext)

    const workDraftFromLocal = workStore.workDraftLocal
    const currentRhId = rightsholderStore.currentRightsholderId

    if (!workDraftFromLocal) {
        return null
    }

    const typeCreator = location.href.split('/')[7] // HARD CODE
    const originPublishers = workDraftFromLocal.originalPublishers
    if (!originPublishers.length) {
        if (workDraftFromLocal.id) {
            return (
                <Navigate
                    to={`/rightsholder/${currentRhId}/catalog/${workDraftFromLocal.isComplete ? 'work' : 'draft'}/${
                        workDraftFromLocal.id
                    }/edit/publishers`}
                />
            )
        }

        return <Navigate to={`/rightsholder/${currentRhId}/create-work/manual/${typeCreator}/publishers`} />
    }

    return (
        <div className="publishers-step relation-step">
            <WizardStepHeading heading="Link Writer" title={workDraftFromLocal.title}>
                To link a writer to a publisher, click the Add Writer button to view all writers on the work. Then,
                select the writer(s) to link and click the Link writers button.
            </WizardStepHeading>

            <div className="publishers-cards-wrapper">
                <div className="publishers-add-area">
                    <div className="publisher-wrapper">
                        <div className="publishers-area">
                            <div className="main-title">
                                <p className="bold title">{Pluralize('Publisher', originPublishers.length)}</p>
                                <span className="small bold blue-text">Required</span>
                            </div>
                            {originPublishers.length &&
                                originPublishers.map((op: OriginalPublisherModel) => (
                                    <div className="op-wrapper" key={op.localId}>
                                        <OriginalPublisherCardAddWriters data={op} />
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(PublishersRelationsStep)
